import React from 'react';
import DarkMarketingPage from '../Shared/DarkMarketingPage';
import Illustration from '../../../images/marketing/webBuilder/Illustration.png';
import Illustration2 from '../../../images/marketing/webBuilder/Illustration2.png';
import Illustration3 from '../../../images/marketing/webBuilder/Illustration3.png';

const sections = [
  {
    label: 'EDITOR',
    title: 'No Drag and Drop',
    description:
      'On EditPage you can directly edit elements from our templates. Choose your category, pick a template, and edit right away.',
    link: '/webbuilder',
    image: Illustration,
  },
  {
    label: 'WORKFLOW',
    title: 'Simple Click and Edit',
    description:
      'Click any text, image, or button and the relevant tools appear. You always know what controls are available for each element.',
    link: '/webbuilder',
    image: Illustration2,
    reverse: true,
  },
  {
    label: 'DESIGN',
    title: 'Simple Color Selection',
    description:
      'Changing color is fast and easy from the toolbar. Gradients and texture options help you personalize your website quickly.',
    link: '/webbuilder',
    image: Illustration3,
  },
];

const quickTags = [
  'No Drag and Drop',
  'Simple Click and Edit',
  'Simple Color Selection',
  'Template Library',
  'Direct Content Editing',
  'Fast Publish Flow',
];

const WebBuilderContent = ({ history }) => (
  <DarkMarketingPage
    history={history}
    title="EditPage Website Builder"
    subtitle="EditPage is a simple, easy and affordable website builder. We make creating your website attainable and convenient."
    sections={sections}
    quickTags={quickTags}
  />
);

export default WebBuilderContent;
